import { render, staticRenderFns } from "./ArticleMetricsModal.vue?vue&type=template&id=26b8ade7&scoped=true&"
import script from "./ArticleMetricsModal.vue?vue&type=script&lang=js&"
export * from "./ArticleMetricsModal.vue?vue&type=script&lang=js&"
import style0 from "./ArticleMetricsModal.vue?vue&type=style&index=0&id=26b8ade7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b8ade7",
  null
  
)

export default component.exports